import React from "react";
import { classIf, oddToString } from "../../data/utils";
import { getLabel } from "../../InitData";
import Img from "../Img";


export default function BetslipVariationModal(props) {
	const data = props.data;
	
    const selections = []; // keeping just the variated data
    for(let ks in data.selections){
    	let takeIt = data.selections[ks].closed;
    	if(!takeIt){
    		const bets = data.selections[ks].bets;
    		for(let kb in bets){
    			takeIt = takeIt || bets[kb].updated || bets[kb].closed;
    		}
    	}
    	
    	if(takeIt){
    		selections.push(data.selections[ks]);
    	}
    }
    
    const amountData = data.amountData;
	function handleDecline(){
		data?.closeFunction && props.data.closeFunction();
	}
	function handleAccept(){
		if(data?.purchaseFunction){
			data?.purchaseFunction();
		}
		handleDecline();
	}

   	return <div className="b_13">
	    <div className="b_14">
	        <div className="b_14_1">{data.advise}</div>
	        {
		        selections.map((selection, selectionIndex) => {
		        	const bets = selection.bets;
		        	return  <div className="b_14_2" key={selectionIndex}>
		        		<div className="b_14_2_1">
							<span className="b_14_2_1_1">{selection.descEvent}</span>
						</div>	
		        	{
		        		selection.closed && <div className="b_14_2_1">
		        			<span className="b_14_2_1_2 closed">{getLabel('general.giocabilita_chiusa')}</span>
		        		</div>
					}
					{		
		        		!selection.closed && <>
		        		{
		        			bets.map((bet, betIndex) => {  
		        			
    			  			return <div className="b_14_2_1" key={betIndex}>
	        					<span className="b_14_2_1_1">{bet.descBet} - {bet.descDraw}</span>
	            				<span className={`b_14_2_1_2${classIf(bet.closed, 'closed')}`}>{bet.closed? getLabel('general.giocabilita_chiusa') : oddToString(bet.odd)}</span>
	            				{
	            					bet.updated &&
	            					<Img className="b_14_2_3" src={bet.updated === 'increased'? "icon_raise_odd.svg" : "icon_drop_odd.svg"} height="12px" width="12px" />
	            				}
	            				
		        			</div>
		        			})
		        		}
		        		
		        		</>
		        	
		        	}
		        	</div>
		        })
	        }
	        <div className="b_14_1">{getLabel('carrello.winnings')} : {amountData.potentialWinning}</div>
	        <div className="b_14_3">
	            <button onClick={handleDecline} type="button" className="c_53">
	                <div className="c_53_1">{getLabel('purchase.check_betslip')}</div>
	            </button>
	            <button onClick={handleAccept} type="button" className="c_52">
	                <div className="c_52_1">{getLabel('purchase.buy_anyway')}</div>
	            </button>
	        </div>
	    </div>
	</div>
}
